import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Portfolio from "./pages/Portfolio";
import { Link, Routes, Route } from 'react-router-dom';
import Abouts from "./pages/Abouts";
import {AiOutlineHome, AiOutlineSetting, AiOutlineContacts, AiOutlineFundProjectionScreen, AiOutlineUser} from "react-icons/ai";
import "./pages/style/navBar.css";

function App() {
  const showSetting = (e) => {
    if((e.target.tagName === "LI" && e.target.attributes.id?.nodeValue) || e.target.tagName === "svg" || e.target.tagName === "path" ||e.target.tagName === "SPAN") {
      // console.log(e.target.attributes.id.nodeValue);
      e.currentTarget.classList.toggle("clicked");
      let list = document.getElementById("sitting");
        ["opacity-[0]", "-left-[10px]"].forEach(cls => list.classList.toggle(cls));
        ["opacity-[1]", "left-[10px]"].forEach(cls => list.classList.toggle(cls));
      }
    }

  const handleActive = (e) => {
    const listLi = e.currentTarget.parentElement.children;
    [...listLi].forEach((li) => {
      li.classList.remove("active");
    });
    e.currentTarget.classList.toggle("active");
  }

  const handleColor = (e) => {
    document.body.style.setProperty("--changed-light-color", `${e.target.dataset.color}9a`);
    document.body.style.setProperty("--changed-color", e.target.dataset.color);
    document.body.style.setProperty("--white-color", "#fff");
    document.body.style.setProperty("--light-text-color", "#b0a696");
    document.body.style.setProperty("--light-green-bg", "#dbeede1f");
  }

  const handleSize = (e) => {
    if(!e.target.classList.contains("clicked")) {
      const lisList = [...e.target.parentElement.children];
      lisList.forEach(el => {
        el.classList.remove("clicked");
      });
      e.target.classList.add("clicked");
    }
    document.body.style.setProperty("--fontSizeChanged", `${e.target.textContent}px`);
  } 

  return (
    <>
      <nav className="shadow min-h-[100vh] p-2 w-[60px] md:w-[170px] relative navBar">
        <div className="max-w-[100px] my-[30px] mx-auto border-b-4 border-dotted logo">
          <img src="/myPortfolio/logoProj.png" alt="logo the theSite" className="theLogo"/>
        </div>
          <ul className="nav-bar flex flex-col gap-4 relative text-[#fff]">
            <li className="md:px-4 active" onClick={handleActive}>
                    <Link to="/" className="flex items-center md:gap-3">
                      <AiOutlineHome className="w-[25px] h-[25px]" />
                      <span className="hidden md:block">Home</span>
                    </Link>
            </li>
            <li className="md:px-4" onClick={handleActive}>
                <Link to={"/abouts"} className="flex items-center md:gap-3 whitespace-nowrap">
                    <AiOutlineUser className="w-[25px] h-[25px]" />
                    <span className="hidden md:block">About Me</span>
                </Link>
            </li>
            <li className="md:px-4" onClick={handleActive}>
                <Link to="/contact" className="flex items-center md:gap-3">
                    <AiOutlineContacts className="w-[25px] h-[25px]" />
                    <span className="hidden md:block">Contact</span>
                </Link>
            </li>
            <li className="md:px-4" onClick={handleActive}>
                <Link to="/portfolio" className="flex items-center md:gap-3">
                    <AiOutlineFundProjectionScreen className="w-[25px] h-[25px]" />
                    <span className="hidden md:block">portfolio</span>
                </Link>
            </li>
            <li className="md:px-4 relative" id="btnStyle" onClick={(e) => showSetting(e)}>
                <Link className="flex items-center md:gap-3">
                    <AiOutlineSetting className="w-[25px] h-[25px]"/>
                    <span className="hidden md:block">Settings</span>
                    <ul id="sitting" className="list-unstyled opacity-[0] absolute transition-[0.3s] flex flex-col gap-2 shadow px-[15px] py-[10px] border-b left-[-10px] top-[110%] w-[fit-content] text-[#fff]">
                      <li className="flex justify-between align-center">Color
                        <ul className="flex gap-2">
                          <li data-color="#e12828" className="rounded-[2px] w-[15px] h-[15px] bg-[#e12828] border transition-[0.3s] hover:rounded-[50%]" onClick={(e) => handleColor(e)}></li>
                          <li data-color="#00b22d" className="rounded-[2px] w-[15px] h-[15px] bg-[#00b22d] border transition-[0.3s] hover:rounded-[50%]" onClick={(e) => handleColor(e)}></li>
                          <li data-color="#009bff" className="rounded-[2px] w-[15px] h-[15px] bg-[#009bff] border transition-[0.3s] hover:rounded-[50%]" onClick={(e) => handleColor(e)}></li>
                          <li data-color="#fc6d26" className="rounded-[2px] w-[15px] h-[15px] bg-[#fc6d26] border transition-[0.3s] hover:rounded-[50%]" onClick={(e) => handleColor(e)}></li>
                        </ul>
                      </li>
                      <li className="flex justify-between align-center gap-[30px]">Font
                        {/* <label htmlFor="txtFont">
                          <input 
                              type="text" 
                              list="listFonts" 
                              name="Font" 
                              id="txtFont" 
                              placeholder="Font" 
                              className="border-0 text-[#fff] focus:outline-0 rounded-[2px] bg-transparent border-b px-1 placeholder:text-[#fff] placeholder:opacity-[0.5]" 
                              value={theFont} 
                              onChange={handleSelect}
                            />
                        </label> */}
                        <select 
                              className="border-0 text-[#fff] flex-1 focus:outline-0 rounded-[2px] bg-transparent border-b px-1" 
                              onChange={e => {
                                if(e.target.value === "")
                                  return "";

                                const [family, path] = e.target.value.split("||");
                                document.querySelector("head link[rel='stylesheet']").setAttribute("href",path)
                                document.body.style.setProperty("--fontFamily", family);
                              }}
                            >
                          <option  value="" className="text-[#555]">Select Font Family</option>
                          <option  value="'Roboto', sans-serif||https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700&display=swap"  className="text-[#555]">Roboto</option>
                          <option  value="'Josefin Sans', sans-serif||https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@300;400;500;600;700&display=swap"  className="text-[#555]">Josefin</option>
                          <option  value=" 'Kumbh Sans', sans-serif||https://fonts.googleapis.com/css2?family=Kumbh+Sans:wght@300;500;600;700;800;900&display=swa" className="text-[#555]">Kumbh</option>
                        </select>
                      </li>
                      <li className="flex justify-between align-center">size
                        <ul className="flex gap-2 list__font--size">
                          <li className="border-b-2" onClick={handleSize}>13</li>
                          <li className="border-b-2" onClick={handleSize}>14</li>
                          <li className="border-b-2 clicked" onClick={handleSize}>15</li>
                          <li className="border-b-2" onClick={handleSize}>16</li>
                          <li className="border-b-2" onClick={handleSize}>17</li>
                          <li className="border-b-2" onClick={handleSize}>18</li>
                        </ul>
                      </li>
                    </ul> 
                </Link>
            </li>
          </ul>
        </nav>

      <Routes>
          <Route index element={<Home />} />
          <Route path="Abouts" element={<Abouts />} />
          <Route path="contact" element={<Contact />} />
          <Route path="Portfolio" element={<Portfolio />} />
      </Routes>
    </>
  );
}

export default App;